'use client'

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html lang="de">
      <body className="min-h-screen flex items-center justify-center bg-background-muted px-4">
        <div className="bg-white p-8 rounded-2xl shadow-lg text-center max-w-md">
          <div className="text-6xl mb-4">⚠️</div>
          <h2 className="text-2xl font-bold text-content-strong mb-4">
            Kritischer Fehler
          </h2>
          <p className="text-content-muted mb-6">
            Die Anwendung konnte nicht geladen werden. Bitte laden Sie die Seite neu.
          </p>
          <button
            onClick={reset}
            className="px-6 py-3 bg-indigo-500 text-white rounded-xl hover:bg-indigo-600 transition-colors font-semibold"
          >
            Seite neu laden
          </button>
        </div>
      </body>
    </html>
  )
}
